import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

import Slide from '@material-ui/core/Slide';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

import User, { UserRoleId } from '../../models/User';

import sideBarStyles from './sideBar.module.css';
import commonStyles from '../common/common.module.css';
import menuIcon from '../../assets/trypod_logo.png';
import profileIcon from '../../assets/profile.png';

import environments from '../../configs/environments';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { Button, MenuItem, OutlinedInput, Select } from '@material-ui/core';
import Counter from '../../models/Counter';

interface SideBarProps {
  menuItems: Array<Array<string>>;
  sidebarTimeout: number;
  checked: boolean;
  handleChange: any;
  user: User;
  signOut: any;
  menuEvent: any;
  height: string;
  ghaUser: any;
  openShuttleTracker: (event: any) => void;
  button?: boolean;
  counters: Array<Counter>;
  counterId: number;
  selectCounter: (e: any) => void;
  showCounter: boolean;
};

const sideBar = (props: SideBarProps) => {

  const { menuItems, sidebarTimeout, checked, handleChange, user, signOut, menuEvent, height, ghaUser } = props;
  const slideWrapperClass: CSSProperties = {
    position: 'absolute',
    width: '310px',
    left: '0px',
    top: '79px',
    height: height,
    zIndex: 3,
  };
  const slideWrapperTop: CSSProperties = {
    top: '0',
  };
  
  let filteredLinks = menuItems;
  if(ghaUser.sideBar) {
    filteredLinks = menuItems.filter(item => {
      const val = item[0].split('/')[1];
      if(ghaUser.sideBar) 
        return !ghaUser.sideBar.includes(val)
      else false;
    });
  }
  const counters = props.counters.length ? props.counters.map((option: Counter, index: number) => {
    return (
      <MenuItem disabled={ option.id_user ? true : false } key={ index } value={ option.id }>{ `${option.name}  ${ option.user && option.user.length > 1 ? `- ${option.user}` : '' }`  }</MenuItem>
    )
  }) : [];


  const isHelpDesk: boolean = !!(props.user.roleId === UserRoleId.GHA_OFFICE || props.user.roleId === UserRoleId.GHA_SUPERVISOR || 
    props.user.roleId === UserRoleId.GHA_MANAGER || props.user.roleId === UserRoleId.GHA_ACCOUNTING ||  props.user.roleId === UserRoleId.GHA_ADMIN ||  props.user.roleId === UserRoleId.LAX_OFFICE_AGENT
    || props.user.roleId === UserRoleId.GHA_WH_SCREENER || props.user.roleId === UserRoleId.GHA_MANAGER_WAREHOUSE || props.user.roleId === UserRoleId.GHA_SUPERVISOR_WAREHOUSE
    || props.user.roleId === UserRoleId.GHA_SUPER_USER);

  return (
    <Fragment>
        
      <div>
        { !props.button ? 
          <div className={sideBarStyles.imgBlock}>
            <img alt="logo" src={ menuIcon } className={ sideBarStyles.img } onClick={ handleChange } />
          </div>
        : <Button
            color="primary"
            variant="contained"
            onClick={ handleChange }
          >
          Menu
        </Button> }
      </div>
      <div style={ !props.button ? slideWrapperClass : { ...slideWrapperClass, ...slideWrapperTop }}>
        <div className={ checked ? sideBarStyles.overlay : ''} onClick={ handleChange }></div>
        <Slide direction={ 'right' } timeout={ sidebarTimeout } in={ checked }>

          <div className={ sideBarStyles.sideBar }>
            <div className={ sideBarStyles.userInfo }>
            <img alt="profile" src={ profileIcon } className={ sideBarStyles.profileImg }/>
              <div className={ sideBarStyles.orgName }>{ user.org }</div>
              <div className={ sideBarStyles.userName }>{ user.firstName }  { user.lastName }</div>
              <div className={ sideBarStyles.user }>{ user.roleName }</div>
              { props.showCounter && props.counters.length ? <div className={`${ commonStyles.fMiddle } ${ sideBarStyles.counterTop }`}>
                <label className={`${ sideBarStyles.counterLabel }`}>Counter #</label>
                <Select
                  className={ sideBarStyles.select }
                  onChange={ (event) => props.selectCounter(event) }
                  value={ props.counterId }
                  input={ <OutlinedInput labelWidth={ 0 } notched={false} /> }
                >
                  <MenuItem value={0}>None</MenuItem>
                  { counters }
                </Select>
              </div> : null }
              <div className={ sideBarStyles.profileWrapper }>
                <button className={ sideBarStyles.signOutBtn } onClick={ signOut } >
               
                <ExitToAppIcon className={sideBarStyles.signOut}/>
                  Sign Out 
                </button>
              </div>
            </div>
            <div className={ sideBarStyles.title }>Menu</div>
            <ul className={`${ sideBarStyles.listStyling1 } ${ !props.button ? '' : sideBarStyles.listStylingHt }`} onClick={ menuEvent }>
              {
                filteredLinks.map((item, index) => {
                  return <li key={ index }>
                      <Link to={ item[0] }>{ item[1] }</Link>
                    </li>
                })
              }
              { isHelpDesk &&
                <li><a target='_blank' href={ environments.helpDeskUrl }>Contact Helpdesk</a></li>
              }
              { (props.ghaUser.stations === 'CVG' || props.ghaUser.stations === 'LAX') && 
                <li><button className={ sideBarStyles.pointer } onClick={ (e: any) => props.openShuttleTracker(e) }>Shuttle Tracker</button></li>  
              }
            </ul>
          </div>

        </Slide>

      </div>

    </Fragment>
  );
}

export default sideBar;